/**
 * 在落地页 第三方结果页带token的情况下 自动在天美贷登录
 */
import axios from '../assets/axios'
import { setKey } from '../assets/utils'

export default (query) => {
  const { onceToken, channelNo, channel } = query
  return new Promise(async (resolve) => {
    if (onceToken) {
      const response = await axios.post('/auth/v2/merchant-auth-common', {
        token: onceToken, channelNo: channel || channelNo
      })
      const data = response?.data || {}
      if (response && data.success) {
        setTimeout(() => {
          setKey('userInfo', Object.assign(data.data, { time: Date.now() }))

          window.$sensors.login(data.data?.userId)
          window.$sensors.registerPage({
            phone_number: data.data?.mobile
          })
        
          localStorage.removeItem('backHome')
          /**
           * {desc} 针对小花流程的回调地址获取
           * @param {successUrl} 借款成功
           * @param {failUrl} 借款失败
           * @param {xhLoanUrl} 首页
           */

          if (channel === 'API-rosewallet') {
            window.$sensors.track('unionLogin', { mobile: data.data?.mobile })
          }
          if (data?.data?.extParam) {
            const { successUrl, failUrl, xhLoanUrl, customerSource, backUrl } = data?.data.extParam
            setKey('rosewalletUrls', {
              successUrl: decodeURIComponent(successUrl), failUrl: decodeURIComponent(failUrl), xhLoanUrl: decodeURIComponent(xhLoanUrl || backUrl)
            })
            if (customerSource) {
              setKey('customerSource', customerSource)
              window.$sensors.registerPage({
                customerSource: customerSource // APP客户端 XCX微信小程序
              })
            }
          }
          resolve(true)
        }, 100)
      } else {
        resolve(false)
      }
    } else {
      resolve(true)
    }
  })
}